<template>
    <AppLayout title="Mostrar Envios Excel">
        <Toast />
            <Breadcrumb route="envios_multiple" page="Envios Pendientes por Procesar" />
            <DataTable :value="envios" dataKey="id">
                <Column header="Orden">
                    <template #body="{ data }">
                    {{ data.num_orden }}
                    </template>
                </Column>
                <Column header="Destinatario">
                    <template #body="{ data }">
                    {{ data.destino.destinatario }}
                    </template>
                </Column>
                <Column header="Peso">
                    <template #body="{ data }">
                    {{ data.productos['0']['peso'] }}
                    </template>
                </Column>
                <Column header="Dirección">
                    <template #body="{ data }">
                    {{ 'Calle ' + data.destino.calle }} {{'Altura ' + data.destino.altura}} {{data.destino.piso === null ? '' :  'Piso ' + data.destino.piso}} {{ data.destino.dpto === null ? '' : 'Dpto ' +   data.destino.dpto}}
                    </template>
                </Column>
                <Column header="CP">
                    <template #body="{ data }">
                    {{ data.destino.cp }}
                    </template>
                </Column>
                <Column header="Provincia">
                    <template #body="{ data }">
                    {{ data.destino.provincia }}
                    </template>
                </Column>
                <Column header="Servicios disponibles" :style="{ minWidth: '200px' }">
                    <template #body="{ data }">
                        <ServiciosSelect :envio="data" @cambio="actualizarArray"/>
                    </template>
                </Column>
                <Column header="Status" style="font-weight: 700; color: red;">
                    <template #body="{ data }" >
                    {{ data.errores === null ? '' : 'Envio con errores, ver en Editar.' }}
                    </template>
                </Column>
                <Column header="Acciones">
                    <template #body="{ data }">
                        <div class="flex space-x-2">
                            <Link
                                :href="
                                    '/envios/' +
                                    data.id +
                                    '/edit'
                                "
                            >
                            <Button>
                                <Icon><PencilAlt /></Icon>
                            </Button>
                            </Link>
                            <Button
                                variant="destructive"
                                @click="confirmDelete(data.id)"
                            >
                                <Icon><Trash /></Icon>
                            </Button>
                        </div>
                    </template>
                </Column>
            </DataTable>
            <!-- Delete Envio dialog -->
            <Dialog
                v-model:visible="deleteEnvioDialog"
                :style="{ width: '450px' }"
                header="Confirmar"
                :modal="true"
            >
                <div class="flex items-center justify-center" style="height: 80px">
                    <i
                        class="pi pi-exclamation-triangle mr-3"
                        style="font-size: 2rem"
                    />
                    <span v-if="envio">
                        ¿Seguro que deseas eliminar el envio número <b>{{ envio }}</b
                        >?
                    </span>
                </div>
                <template #footer>
                    <div class="flex justify-end space-x-2">
                        <Button @click="deleteEnvioDialog = false"
                            >Cancelar</Button
                        >
                        <Button variant="destructive" @click="deleteEnvio"
                            >Eliminar</Button
                        >
                    </div>
                </template>
            </Dialog>
            <div class="m-4 flex justify-end">
                <Button @click.prevent="procesarEnvio" :disabled="noDisponible"> Procesar Envios </Button>
            </div>
    </AppLayout>
</template>
<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import ServiciosSelect from "./components/ServiciosSelect.vue";
import { PencilAlt, Trash } from "@vicons/fa";
import axios from "axios";
import { Inertia } from "@inertiajs/inertia";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
        ServiciosSelect,
        PencilAlt,
        Trash,
        axios,
        Inertia,
    },
    props: ["envios"],
    data() {
        return {
            form:{
                servicioId: null,
                envioId: null,
            },
            colectar: [],
            deleteEnvioDialog: false,
            envio: {},
            noDisponible: false,
        };
    },
    methods: {
        actualizarArray(envioSel){
            let id = envioSel.envioId;
            let existe = this.colectar.find((envio) => envio.envioId === id);
            if (existe){
                this.colectar = this.colectar.map((envio) => {
                    if(envio.envioId === id){
                        return {
                            envioId: envioSel.envioId,
                            servicioId: envioSel.servicioId,
                        }
                    } else {
                        return envio
                    }
                })
            } else {
                this.colectar.push(envioSel);
            };
        },
        procesarEnvio(){
            this.noDisponible = true;
            this.$inertia.post("proceso_envio", this.colectar, {
                onSuccess: () => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Exito",
                        detail: "Envio Creado con Exito",
                        life: 3000,
                    });
                    this.noDisponible = false;
                },
            });
        },
        confirmDelete(envio) {
            this.envio = envio;
            this.deleteEnvioDialog = true;
        },
        deleteEnvio() {
            this.deleteEnvioDialog = false;
            this.$inertia.form().delete(`/envios_multiple/${this.envio}`, {
                onSuccess: () => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Exito",
                        detail: "Envio eliminado",
                        life: 3000,
                    });
                }
            });
        },
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>